import { createContext, useContext, useState } from "react";
import { Language } from "types/locale";
import { getStoredLanguage } from "utils/get-language";

interface LanguageContextValue {
  lang: Language;
  setLang: (l: Language) => void;
}

const LanguageContext = createContext<LanguageContextValue>({
  lang: Language.Lt,
  setLang: () => {},
});

const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [lang, setLangState] = useState<Language>(getStoredLanguage);
  const setLang = (l: Language) => {
    localStorage.setItem("lang", l);
    setLangState(l);
  };
  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => useContext(LanguageContext);

export default LanguageProvider;
